export * from './components/messages/messages.component';
export * from './messages.module';



// WEBPACK FOOTER //
// ./src/app/messages/index.ts